import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

export const ANIMATION_DELAY = 200
const border = '1px solid #C6C6C6'

interface EngagementHubV2StyleProps {
  open?: boolean
}
const useStyles = makeStyles<Theme, EngagementHubV2StyleProps>(theme => ({
  root: {
    borderLeft: border,
    boxSizing: 'border-box',
    backgroundColor: '#F5F6F8',
    overflow: 'hidden',
    width: ({ open }) => `${open ? '100%' : '0px'}`
  },

  rootLeft: {
    borderLeft: 'none',
    borderRight: border
  },

  accordionRoot: {
    overflowY: 'auto',
    maxHeight: 'calc(100svh - 169px)',

    [theme.breakpoints.down('md')]: {
      maxHeight: 'calc(100svh - 244px)'
    }
  },

  spacer: {
    height: 8,
    backgroundColor: 'white'
  },

  button: {
    position: 'absolute',
    zIndex: 2,
    top: 30,
    right: ({ open }) => `${open ? `220px` : `10px`}`,
    cursor: 'pointer',
    transform: ({ open }) => `translateX(50%) rotate(${!open ? 0 : 180}deg)`
  }
}))

export default useStyles
